import { StateCreator } from "zustand";
import { GlobalState } from "../globalStore";
import type {
  Profile,
  // UserPreferencesOutput,
  // PersonalInfo,
  PersonalData,
  PrintSettings,
} from "@/generated/fastapi";

// Use in the the app where needed
export const userProfileStateInitData: Profile = {
  id: "",
  latest_at: null, // Initialize with empty profile data
  roles: [],

  // preferences: {},
  print_settings: {} as PrintSettings,

  // personal_info: {},
  personal_data: {} as PersonalData,
};

export interface UserProfileState {
  data: Profile;
  isLoading: boolean;
  error: string | null;
}

export interface UserProfileSlice {
  userProfile: UserProfileState;
  setUserProfile: (profile: Profile) => void;
  setUserProfileLoading: () => void;
  setUserProfileError: (error: string) => void;
  resetUserProfile: () => void;
  // updateUserProfilePreferences: (
  //   preferences: UserPreferencesOutput,
  // ) => UserPreferencesOutput;
  // updateUserProfilePersonalInfo: (personalInfo: PersonalInfo) => PersonalInfo;
  updateUserProfilePersonalData: (personalData: PersonalData) => PersonalData;
  updateUserProfilePrintSettings: (
    printSettings: PrintSettings,
  ) => PrintSettings;
  // Initial state loading
  initFetchedUserProfile: boolean;
  setInitFetchedUserProfile: (fetched: boolean) => void;
}

export const createUserProfileSlice: StateCreator<
  GlobalState,
  [],
  [],
  UserProfileSlice
> = (set, get) => ({
  //* Basic state manipulation
  userProfile: {
    data: userProfileStateInitData, // Initialize with empty profile data
    isLoading: false,
    error: null,
  },
  setUserProfile: (profile) =>
    set({
      userProfile: { data: profile, isLoading: false, error: null },
    }), // Note the difference: Direct assignment to the state object, completely replacing it
  setUserProfileLoading: () =>
    set((state) => ({
      userProfile: { ...state.userProfile, isLoading: true, error: null },
    })), // Note the difference: Using a function to update the state object, merging the
  // new data with the existing state ... because loading state needs to know about the previous state
  setUserProfileError: (error) =>
    set((state) => ({
      userProfile: { ...state.userProfile, error, isLoading: false },
    })),
  resetUserProfile: () =>
    set({
      userProfile: {
        // data: { id: "", latest_at: null, roles: [] },
        data: userProfileStateInitData,
        isLoading: false,
        error: null,
      },
    }),
  // updateUserProfilePreferences: (preferencesUpdate) => {
  //   // Store current preferences before updating
  //   const previousPreferences = { ...get().userProfile.data.preferences };

  //   // Update only the preferences part of the profile
  //   set((state) => ({
  //     userProfile: {
  //       ...state.userProfile,
  //       data: {
  //         ...state.userProfile.data,
  //         preferences: {
  //           ...state.userProfile.data.preferences,
  //           ...preferencesUpdate,
  //         },
  //       },
  //       isLoading: false,
  //       error: null,
  //     },
  //   }));

  //   // Return the previous preferences
  //   return previousPreferences;
  // },
  // updateUserProfilePersonalInfo: (personalInfoUpdate) => {
  //   // Store current personal info before updating
  //   const previousPersonalInfo = { ...get().userProfile.data.personal_info };

  //   // Update only the personal_info part of the profile
  //   set((state) => ({
  //     userProfile: {
  //       ...state.userProfile,
  //       data: {
  //         ...state.userProfile.data,
  //         personal_info: {
  //           ...state.userProfile.data.personal_info,
  //           ...personalInfoUpdate,
  //         },
  //       },
  //       isLoading: false,
  //       error: null,
  //     },
  //   }));

  //   // Return the previous personal info
  //   return previousPersonalInfo;
  // },
  updateUserProfilePersonalData: (personalDataUpdate) => {
    // Store current personal data before updating
    const previousPersonalData = { ...get().userProfile.data.personal_data };

    // Update the personal_data part of the profile
    set((state) => ({
      userProfile: {
        ...state.userProfile,
        data: {
          ...state.userProfile.data,
          personal_data: personalDataUpdate,
        },
        isLoading: false,
        error: null,
      },
    }));

    // Return the previous personal data
    return previousPersonalData;
  },
  updateUserProfilePrintSettings: (printSettingsUpdate) => {
    // Store current print settings before updating
    const previousPrintSettings = { ...get().userProfile.data.print_settings };

    // Update the print_settings part of the profile
    set((state) => ({
      userProfile: {
        ...state.userProfile,
        data: {
          ...state.userProfile.data,
          print_settings: printSettingsUpdate,
        },
        isLoading: false,
        error: null,
      },
    }));

    // Return the previous print settings
    return previousPrintSettings;
  },

  // Initial state loading
  initFetchedUserProfile: false,
  setInitFetchedUserProfile: (fetched) =>
    set({ initFetchedUserProfile: fetched }),
});
